export var LIFECYCLE_ERROR_CODES;
(function (LIFECYCLE_ERROR_CODES) {
    LIFECYCLE_ERROR_CODES[LIFECYCLE_ERROR_CODES["USER_DENIED_TX"] = 4001] = "USER_DENIED_TX";
})(LIFECYCLE_ERROR_CODES || (LIFECYCLE_ERROR_CODES = {}));
